import getConfig from 'next/config'

const configs = () => getConfig?.()?.publicRuntimeConfig || {}

export const commonLib = (imgPath: string, c = configs()) => `${c.cdnBasePath}${c.cdnCommonLib}${c.cdnImage}${imgPath}`

export const commonShared = (imgPath: string, c = configs()) =>
  `${c.cdnBasePath}${c.cdnImage}${imgPath}`

export const defaultTemplate = (imgPath: string, c = configs()) =>
  `${c.cdnBasePath}${c.cdnDefaultTemplate}${c.cdnImage}${imgPath}`

export const p10nTemplate = (imgPath: string, c = configs()) =>
  `${c.cdnBasePath}${c.cdnP10nTemplate}${c.cdnImage}${imgPath}`

export const shopHelp = (imgPath: string, c = configs()) => `${c.cdnBasePath}${c.cdnShopHelp}${c.cdnImage}${imgPath}`

export const iconPath = (iconName: Types.IconSet, c = configs()) =>
  `${c.cdnBasePath}${c.cdnIcon}${iconName}.svg`
